import { render } from "./AddChecklistItem.vue?vue&type=template&id=b5bad3e2"
import script from "./AddChecklistItem.vue?vue&type=script&lang=js"
export * from "./AddChecklistItem.vue?vue&type=script&lang=js"
script.render = render

export default script